import axios, { AxiosInstance } from 'axios';

const API_URL = 'https://stylist-api.mannequin.com';

export default function createApiClient(): AxiosInstance {
  const api = axios.create({
    baseURL: API_URL,
  });

  return api;
}
